import { useTranslation } from "react-i18next";
import { AccountCircleOutlined, LogoutOutlined } from "@mui/icons-material";
import { PathConstant } from "@/const";
import { SideBarItemType } from "@/types/view";
import { StorageUtils } from "@/utils";
import { useLoading } from "@/hooks";
import { isElectron } from "@/utils/common.utils";
import { useNavigate } from "react-router-dom";

const SdkLib: any = (window as any).e2eSdk;

const useMenuHeader = () => {
  const { t: getLabel } = useTranslation();
  const { openLoading } = useLoading();
  const navigate = useNavigate();

  const logout = async () => {
    openLoading(true);
    try {
      if (isElectron()) {
        await SdkLib.logout();
      }
    } catch (e) {
      console.warn("Logout API failed:", e);
    } finally {
      StorageUtils.clear();
      openLoading(false);
      navigate(PathConstant.LOGIN);
      window.location.reload();
    }
  };

  const menuList: SideBarItemType[] = [
    {
      key: "info",
      title: getLabel("OBJ_MENU_HEADER.info"),
      url: PathConstant.PROFILE,
      icon: <AccountCircleOutlined />,
    },
    {
      key: "logout",
      title: getLabel("OBJ_MENU_HEADER.logout"),
      url: "",
      icon: <LogoutOutlined />,
      onClick: logout,
    },
  ];

  return {
    menuList: menuList.filter(menu => !Boolean(menu.isHide)),
  };
};

export default useMenuHeader;
